/* eslint-disable import/prefer-default-export */
import * as types from "./actionTypes";

export const userFeedback = (data) => ({
  type: types.POST_USER_FEEDBACK_DATA,
  payload: data,
});

export const userFeedbackDismissal = (data) => ({
  type: types.POST_USER_FEEDBACK_DISMISSAL,
  payload: data,
});

export const userFeedbackClose = () => ({
  type: types.POST_USER_FEEDBACK_CLOSE,
});
